(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order.js');
"use strict";


const getOrderStatus = svs.ticket_partner.myOrders.utils.getOrderStatus;
const DOWNLOAD = svs.ticket_partner.myOrders.constants.TEXTS.ORDER_STATES.DOWNLOAD;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.components,
  OrderTable = _svs$ticket_partner$m.OrderTable,
  DownloadOrder = _svs$ticket_partner$m.DownloadOrder;
const Order = order => {
  const ordered = order.ordered,
    state = order.state;
  const status = getOrderStatus(state);
  const orderDate = svs.utils.date.SimpleDate(new Date(ordered));
  return React.createElement("div", {
    className: "u-text-left margin-top-1 margin-bottom-1"
  }, React.createElement("h2", null, orderDate), status === DOWNLOAD ? React.createElement(DownloadOrder, order) : React.createElement("p", null, status), React.createElement(OrderTable, order));
};
svs.ticket_partner.myOrders.components.Order = Order;

 })(window);